import { CssBaseline, ThemeProvider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useGetPermissionsQuery } from "src/shared/api/rbac/rbac";
import { ReactComponent as Sprite } from "src/shared/assets/svg/sprite.icons.svg";
import { Loader } from "src/shared/components";
import { AuthProvider } from "src/shared/lib/rback/AuthContext";
import { extractPermissions } from "src/shared/lib/rback/extractPermissions";
import { setUserAuthentication } from "src/shared/lib/store/slices/auth";
import { BreadcrumbsProvider } from "src/shared/providers/BreadcrumbsProvider";
import { SnackbarProvider } from "src/shared/providers/withSnackbar";
import { theme } from "src/shared/theme/theme";
import { Router } from "../index";
import "dayjs/locale/ru";

dayjs.locale("ru");

export const App = () => {
  const { data, isLoading, isError, error } = useGetPermissionsQuery(undefined);

  if (isLoading) {
    return <Loader position="absolute" />;
  }

  if (error && "status" in error && error.status === 403) {
    if (window.location.pathname !== "/403") {
      window.location.href = "/403";
    }

    return null;
  }

  if (!data || isError) {
    setUserAuthentication(false);

    if (window.location.pathname !== "/auth/signin") {
      window.location.href = "/auth/signin";
    }

    return null;
  }

  const extractedPermissions = extractPermissions(data.data);

  return (
    <div className="app">
      <AuthProvider permissions={extractedPermissions}>
        <ThemeProvider theme={theme}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Sprite />
            <CssBaseline />
            <SnackbarProvider>
              <BreadcrumbsProvider>
                <Router />
              </BreadcrumbsProvider>
            </SnackbarProvider>
          </LocalizationProvider>
        </ThemeProvider>
      </AuthProvider>
    </div>
  );
};
